import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Toggle visibility of dashboard monetary metric cards.
 */
const DashboardAmountVisibilityToggle = ({
  amountsVisible,
  onToggle,
  className = '',
}) => (
  <button
    type="button"
    onClick={onToggle}
    className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-xl border border-gray-200 bg-surface text-gray-600 hover:bg-surface-muted transition-colors ${className}`}
    title={amountsVisible ? 'Hide amount cards' : 'Show amount cards'}
    aria-pressed={!amountsVisible}
    aria-label={amountsVisible ? 'Hide amount cards' : 'Show amount cards'}
  >
    {amountsVisible ? <Eye className="w-3.5 h-3.5" /> : <EyeOff className="w-3.5 h-3.5" />}
    <span className="hidden sm:inline">{amountsVisible ? 'Hide amounts' : 'Show amounts'}</span>
  </button>
);

export default DashboardAmountVisibilityToggle;
